module.exports = __webpack_public_path__ + "img/how_to_use02_img.b9bd2700.png";